import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../../../environments/environment';


@Injectable()
export class OrderConfirmationService {
  private API_URL = environment.API_URL;
  constructor(private http: Http) {
  }

  getChangeReasons(changed_field) {
    return this.http.get(this.API_URL + '/api/order/reasons/' + changed_field).map((res: Response) => res.json());
  }

  getByConfirmationKey(key) {
    // let headers = new Headers();
    // this.createAuthorizationHeader(headers);
    return this.http.get(this.API_URL + '/api/orderconfirmation/' + key).map((res: Response) => res.json());
  }

  sendConfirmation(doc,key) {
    // let headers = new Headers();
    // this.createAuthorizationHeader(headers);
    let body = JSON.stringify(doc);
    return this.http.put(this.API_URL + '/api/orderconfirmation/' + key, body, ).map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/user/orderconfirmation/orderconfirmation.service.ts